<template>
  <Section
    :id="id"
    :header="t('rateShop.charges.charges', 2)"
    class="carrier-portal-charges-section"
  >
    <DataTable
      :value="charges"
      class="rate-detail-table p-datatable-sm"
      auto-layout
    >
      <Column
        :header="t('rateShop.charges.description')"
        field="description"
        class="w-1"
      />
      <Column :header="t('rateShop.charges.amount')" class="w-1 text-right">
        <template #body="{ data: rateQuoteCharge }">
          <div class="text-right">
            {{
              rateQuoteCharge.charge >= 0
                ? renderMoney(rateQuoteCharge.charge, {
                    currencyCode: currencyCode,
                  })
                : '-'
            }}
          </div>
        </template>
        <template #footer>
          <div class="text-right text-success font-medium">
            {{
              renderMoney(totalPrice, {
                currencyCode: currencyCode,
              })
            }}
          </div>
        </template>
      </Column>
    </DataTable>
  </Section>
</template>

<script lang="ts" setup>
import { computed, PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { renderMoney } from '@rygen/rygen-ui/i18n';
import { Currency } from '@rygen/rygen-ui/model';

import { RateQuoteCharge } from '@/model/rate/RateQuoteCharge';

import Section from '@rygen/rygen-ui/components/ui/Section.vue';
import Column from 'primevue/column';
import DataTable from 'primevue/datatable';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  charges: {
    type: Array as PropType<RateQuoteCharge[]>,
    default: () => [],
  },
  currencyCode: {
    type: String as PropType<Currency>,
    default: () => Currency.USD,
  },
});
const { id, charges, currencyCode } = toRefs(props);

const { t } = useI18n();

const totalPrice = computed(() => {
  const total = charges.value.reduce((sum, c) => sum + c.charge, 0);
  return total >= 0 ? total : undefined;
});
</script>
